// extracted by mini-css-extract-plugin
export var centerText = "_d3-8";
export var container = "_d3-0";
export var doughnutContainer = "_d3-7";
export var legend = "_d3-a";
export var legendItemColorDisplay = "_d3-b";
export var legendItemLabel = "_d3-d";
export var legendItemValue = "_d3-c";
export var lg = "_d3-5";
export var maxWidth = "_d3-9";
export var md = "_d3-4";
export var responsive = "_d3-6";
export var sm = "_d3-3";
export var xs = "_d3-2";
export var xxs = "_d3-1";